import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Box, IconButton, Stack } from '@mui/material';
import { useForm } from 'react-hook-form';

import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { PrimaryOutlinedButton } from '../../../components/style/ButtonStyle';
import { CommonDivider } from '../../../components/style/CommonStyle';
import { FormTitle, MobileTitle } from '../../../components/style/TextStyle';
import { useAuthAxios } from '../../../hooks/useAuthAxios';
import useResponsive from '../../../hooks/useResponsive';
import { useYupValidationResolver } from '../../../hooks/useYupValidationResolver';
import { responsiveMargin } from '../../../utils/enum';
import { TextInput } from '../MapPage/FacilityFormPage/CommonForm';
import { AddUserButton } from './Common/AddUserButton';
import { defaultValue, userSchema } from './Common/DefaultAndSchema';
import UserInputs from './Common/UserInputs';

export default function CreateUserPage() {
  const mdUp = useResponsive('up', 'md');
  const resolver = useYupValidationResolver(
    Yup.object().shape({
      ...userSchema,
      id: Yup.string()
        .min(2, '최소 2자리이상 입력해주세요.')
        .max(100, '최대 100자리입니다.')
        .required('필수 입력값입니다.'),
    }),
  );

  const form = useForm<any>({
    mode: 'onTouched',
    resolver,
    defaultValues: {
      ...defaultValue,
      id: '',
    },
    shouldUnregister: false,
  });

  const [postUserResult, postUser] = useAuthAxios({
    method: 'POST',
    url: '/api/v1/user',
  });

  const onSubmit = form.handleSubmit(function (values) {
    const payload = {
      administrativeRegion: values.administrativeRegion,
      createdAt: values.createdAt,
      departmentId: values.departmentId,
      email: values.email,
      id: values.id,
      name: values.name,
      phone: values.phone,
      role: values.role,
      userId: values.userId,
    };
    postUser({ data: payload });
  });

  return (
    <Stack mx={responsiveMargin} spacing={5} my={{ xs: 2, md: 10 }}>
      {mdUp ? (
        <DesktopHeader postUserResult={postUserResult} onSubmit={onSubmit} />
      ) : (
        <MobileHeader postUserResult={postUserResult} onSubmit={onSubmit} />
      )}
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        sx={{ w: '100%' }}
        spacing={5}
      >
        <Stack sx={{ flex: 1 }}>
          <TextInput
            form={form}
            isRequired={true}
            label="ID"
            fieldPath="id"
            placeholder="예시 : tester1"
          />
        </Stack>
        <Stack sx={{ flex: 1 }}>
          <TextInput
            form={form}
            isRequired={true}
            label="이름"
            fieldPath="name"
            placeholder="예시 : 홍길동"
          />
        </Stack>
      </Stack>
      <UserInputs form={form} />
    </Stack>
  );
}

function DesktopHeader({ postUserResult, onSubmit }: any) {
  const navigate = useNavigate();
  return (
    <>
      <IconButton
        sx={{ width: 'fit-content', justifyContent: 'flex-start' }}
        onClick={() => navigate(`/users`)}
      >
        <KeyboardArrowLeftIcon />
      </IconButton>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <FormTitle>새 이용자 등록</FormTitle>
        <Box />
        <Stack direction="row" spacing={1}>
          <PrimaryOutlinedButton
            sx={{ width: 130, height: 40 }}
            onClick={() => {
              navigate(`/users`);
            }}
          >
            취소
          </PrimaryOutlinedButton>
          <AddUserButton
            isDesktop={true}
            onSubmit={onSubmit}
            postUserResult={postUserResult}
          />
        </Stack>
      </Stack>
      <CommonDivider />
    </>
  );
}

function MobileHeader({ postUserResult, onSubmit }: any) {
  const navigate = useNavigate();
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <IconButton
        sx={{ width: 'fit-content', justifyContent: 'flex-start' }}
        onClick={() => navigate(`/users`)}
      >
        <KeyboardArrowLeftIcon />
      </IconButton>
      <MobileTitle>새 이용자 등록</MobileTitle>
      <AddUserButton
        isDesktop={false}
        onSubmit={onSubmit}
        postUserResult={postUserResult}
      />
    </Stack>
  );
}
